var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "portal",
    [
      _c("transition", { attrs: { name: "zoom-out" } }, [
        _vm.value
          ? _c(
              "div",
              {
                class: `redui-modal ${_vm.classes}`,
                attrs: { tabindex: "-1" },
              },
              [
                _c("div", { staticClass: "modal-mask" }),
                _vm._v(" "),
                _c("div", { style: `max-width: ${_vm.maxWidth}px` }, [
                  _c("div", { staticClass: "modal-container" }, [
                    _vm.showHeader
                      ? _c(
                          "header",
                          { staticClass: "modal-header" },
                          [_vm._t("header")],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "section",
                      { staticClass: "modal-body" },
                      [_vm._t("content"), _vm._v(" "), _vm._t("default")],
                      2
                    ),
                    _vm._v(" "),
                    _vm.showFooter
                      ? _c(
                          "footer",
                          { staticClass: "modal-footer" },
                          [
                            _vm._t("footer", function () {
                              return [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-cancel",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit("input", false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("close")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }